import CrudCustom from '../../../libs/custom/CrudCustom';

let PemotonganPPh2126Service = new CrudCustom('/pemotongan-pph2126s');
export default PemotonganPPh2126Service;
